function Contact () {
    return(
        <div className="contact">
            <h1>CONTACT</h1>
        </div>
    );
}

export default Contact;